export const checkEditPermissions = (projectData, isAdmin) => {
  if (!isAdmin) {
    return {
      canEdit: false,
      message: 'Only administrators can edit projects.'
    };
  }

  if (!projectData) {
    return {
      canEdit: false,
      message: 'Project data not available.'
    };
  }

  const status = (projectData.status || '').toUpperCase();

  // Check if project is in ACTIVE status
  if (status !== 'ACT' && status !== 'ACTIVE') {
    const statusMessages = {
      'TER': 'Cannot edit terminated projects.',
      'TERMINATED': 'Cannot edit terminated projects.',
      'CLO': 'Cannot edit closed projects.',
      'CLOSED': 'Cannot edit closed projects.',
      'INV': 'Cannot edit invoiced projects.',
      'INVOICED': 'Cannot edit invoiced projects.',
      'APP': 'Cannot edit approved projects.',
      'INVOICE_APPROVED': 'Cannot edit approved projects.',
      'INS': 'Cannot edit projects ready for invoice.',
      'PAY': 'Cannot edit projects with payment received.',
      'PAYMENT_RECEIVED': 'Cannot edit projects with payment received.'
    };

    return {
      canEdit: false,
      message: statusMessages[status] || `Cannot edit projects with status: ${status}`
    };
  }

  // If all checks pass, allow editing
  return {
    canEdit: true,
    message: null
  };
};